import {EventBus} from "../../../../common/ts/events/EventBus";
import dom from "../../../../common/ts/core/dom";
import tracking from "../../../../common/ts/core/tracking";

import {FilterButtonClickedEvent, FiltersSubmittedEvent} from "./events";
import location from "../../../../common/ts/core/location";
import {
    FILTER_NAMES,
    FILTERS_BUTTON_SELECTOR,
    FILTERS_CLEAR_ALL_BUTTON_SELECTOR,
    FILTERS_MODAL_FORM_SELECTOR, MODAL_FILTERS_CONTAINER_SELECTORS
} from "../../../../common/ts/serp/filters/constants";
import {MitulaSerpPageData} from "../SerpPage";
import {getFormDataSubmittingFromFiltersModal, getTrackingFormData} from "./filterFormData";
import {HIDDEN_CLASS} from "../../../../common/ts/components/description/constants";

const OPERATION_TYPE_BUTTON_SELECTOR = '#operation-type-filter';
const PROPERTY_TYPE_BUTTON_SELECTOR = '#property-type-filter';
const FREE_TEXT_BUTTON_SELECTOR = '#free-text-filter';
const PRICE_BUTTON_SELECTOR = '#price-filter';
const ROOMS_BUTTON_SELECTOR = '#rooms-filter';
const AREA_BUTTON_SELECTOR = '#area-filter';
const BATHROOMS_BUTTON_SELECTOR = '#bathrooms-filter';
const SORTING_BUTTON_SELECTOR = '#sorting-filter';
const AMENITIES_BUTTON_SELECTOR = '#amenities-filter';
const GEO_CHILDREN_BUTTON_SELECTOR = '#geo-children-filter';
const STRATUM_BUTTON_SELECTOR = '#stratum-filter';
const FILTER_BUTTON_SELECTORS: { [key: string]: string } = {
    [FILTER_NAMES.OPERATION_TYPE]: OPERATION_TYPE_BUTTON_SELECTOR,
    [FILTER_NAMES.PROPERTY_TYPE]: PROPERTY_TYPE_BUTTON_SELECTOR,
    [FILTER_NAMES.PRICE]: PRICE_BUTTON_SELECTOR,
    [FILTER_NAMES.ROOMS]: ROOMS_BUTTON_SELECTOR,
    [FILTER_NAMES.BATHROOMS]: BATHROOMS_BUTTON_SELECTOR,
    [FILTER_NAMES.AREA]: AREA_BUTTON_SELECTOR,
    [FILTER_NAMES.SORTING]: SORTING_BUTTON_SELECTOR,
    [FILTER_NAMES.AMENITIES]: AMENITIES_BUTTON_SELECTOR,
    [FILTER_NAMES.FREE_TEXT]: FREE_TEXT_BUTTON_SELECTOR,
    [FILTER_NAMES.GEO_CHILDREN_ID]: GEO_CHILDREN_BUTTON_SELECTOR,
    [FILTER_NAMES.STRATUM]: STRATUM_BUTTON_SELECTOR,
};

let isOpen: boolean = false;
let eventBus: EventBus;
const filtersModal: HTMLElement = document.getElementById('serp-filters-modal')!;
const closeFiltersModalButton: HTMLElement = document.getElementById('close-serp-filters-modal')!;

function init(ev: any = EventBus.getInstance(), pageData: MitulaSerpPageData) {
    eventBus = ev;
    registerOpenModalListener();
    registerCloseModalListener();
    registerSubmitButtonFiltersListener(pageData);
}

function isModalOpen(): boolean {
    return isOpen;
}

function registerCloseModalListener() {
    if (closeFiltersModalButton) {
        closeFiltersModalButton.addEventListener('click', () => {
            filtersModal.classList.remove('displayed');
            eventBus.emit(new dom.AddClassEvent({selector: FILTERS_CLEAR_ALL_BUTTON_SELECTOR, className: HIDDEN_CLASS}));
            document.body.style.overflow = 'auto';
            isOpen = false;
            toggleGeoSelector(true)
        })
    }
}

function openModalListener(filterName?: string) {
    isOpen = true;
    filtersModal.classList.add('displayed');
    document.body.style.overflow = 'hidden';
    eventBus.emit(new FilterButtonClickedEvent({filterName}))
    eventBus.emit(new tracking.TrackAnalyticsEvent({name: 'serp-search-bar-filters-button'}))
    eventBus.emit(new tracking.TrackWebTrackingEvent({type: "FiltersModalOpened", serpUrl: window.location.href}))
}

function registerOpenModalListener() {
    eventBus.emitMany(
        [
            new dom.AddClickListenerEvent({
                selector: FILTERS_BUTTON_SELECTOR,
                listener: () => {
                    registerFiltersButtonListeners();
                },
            }),
            ...Object.values(FILTER_NAMES)
                .map(createEventListenerEventForFilter)
        ],
    )
}

function createEventListenerEventForFilter(filterName: string) {
    return new dom.AddClickListenerEvent({
        selector: FILTER_BUTTON_SELECTORS[filterName],
        listener: () => openModalListener(filterName),
    });
}

function registerFiltersButtonListeners() {
    eventBus.emit(new dom.RemoveClassEvent({selector: FILTERS_CLEAR_ALL_BUTTON_SELECTOR, className: HIDDEN_CLASS}));
    toggleGeoSelector(false);
    openModalListener()
}


function registerSubmitButtonFiltersListener(pageData: MitulaSerpPageData) {

    dom.select(FILTERS_MODAL_FORM_SELECTOR)?.addEventListener('submit', (e: Event) => {
        e.preventDefault();

        const searchParams = new URLSearchParams(location.getQueryParams());
        const formData = getFormDataSubmittingFromFiltersModal();

        eventBus.emitMany([
            new FiltersSubmittedEvent({
                formData: formData,
                searchParams,
                type: FiltersSubmittedEvent.MODAL_TYPE,
            }),
            new tracking.TrackWebTrackingEvent({
                type: "FiltersUpdated",
                serpUrl: window.location.href,
                filters: getTrackingFormData(formData, searchParams),
            }),
        ]);
    });
}

function toggleGeoSelector(show: boolean) {
    const event = show ? dom.RemoveClassEvent : dom.AddClassEvent;
    eventBus.emit(new event({
        selector: MODAL_FILTERS_CONTAINER_SELECTORS[FILTER_NAMES.GEO_CHILDREN_ID],
        className: HIDDEN_CLASS
    }));
}

export default {
    init,
    isModalOpen,
}